export { default } from './QuickViewModal'
export * from './QuickViewModal'
